<template>
  <div class="wizard-chart-wrap" :style="{ height: height + 'px' }">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

Chart.defaults.global.defaultFontFamily = "'Raleway', sans-serif"
Chart.defaults.global.defaultFontSize = 11

export default {
  name: 'WizardChart',
  props: {
    type:      { type: String,  required: true },
    chartData: { type: Object,  required: true },
    options:   { type: Object,  default: function() { return {} } },
    height:    { type: Number,  default: 220 },
    plugins:   { type: Array,   default: function() { return [] } },
  },
  data: function() { return { chart: null } },
  beforeDestroy: function() { this.destroyChart() },
  watch: {
    chartData: {
      // immediate: true gère à la fois le premier rendu et les changements ultérieurs.
      // Sans deep: true : Chart.js 2.x mute les datasets (_meta) mais ne peut pas
      // déclencher ce watcher (surveille la référence, pas les propriétés internes).
      // Sans mounted() séparé : évite le double-build dans le même $nextTick (deux
      // instances Chart.js sur le même canvas → la première répond encore aux hover).
      immediate: true,
      handler: function() {
        var self = this
        self.$nextTick(function() {
          self.destroyChart()
          self.buildChart()
        })
      },
    },
  },
  methods: {
    buildChart: function() {
      if (!this.$refs || !this.$refs.canvas) return
      var ctx = this.$refs.canvas.getContext('2d')
      var data = JSON.parse(JSON.stringify(this.chartData))
      var options = this.options
      // camemberts (13/10/2026) : infobulle HTML, qui peut déborder du petit canevas (le texte y était tronqué)
      if (this.type === 'doughnut' || this.type === 'pie') {
        options = Object.assign({}, this.options, {
          tooltips: Object.assign({}, this.options.tooltips || {}, { enabled: false, custom: this.infobulleHtml }),
        })
      }
      this.chart = new Chart(ctx, {
        type: this.type,
        data: data,
        options: options,
        plugins: this.plugins,
      })
    },
    infobulleHtml: function(modele) {
      var el = this.infobulle
      if (!el) {
        el = this.infobulle = document.createElement('div')
        el.className = 'wizard-chart-infobulle'
        el.setAttribute('role', 'tooltip')
        document.body.appendChild(el)
      }
      if (!modele || modele.opacity === 0 || !modele.body) { el.style.opacity = '0'; return }
      var lignes = []
      modele.body.forEach(function(b) { lignes = lignes.concat(b.lines) })
      el.textContent = ''
      lignes.forEach(function(l) { var d = document.createElement('div'); d.textContent = l; el.appendChild(d) })
      var r = this.$refs.canvas.getBoundingClientRect()
      el.style.left = (r.left + window.pageXOffset + modele.caretX) + 'px'
      el.style.top = (r.top + window.pageYOffset + modele.caretY) + 'px'
      el.style.opacity = '1'
    },
    destroyChart: function() {
      if (this.chart) { this.chart.destroy(); this.chart = null }
      if (this.infobulle) { this.infobulle.remove(); this.infobulle = null }
    },
  },
}
</script>

<style scoped>
.wizard-chart-wrap {
  position: relative;
  width: 100%;
}
.wizard-chart-wrap canvas {
  width: 100% !important;
}
</style>

<style>
/* infobulle des camemberts, hors du canevas (non scopé : ajoutée au <body>) */
.wizard-chart-infobulle {
  position: absolute; z-index: 2000; pointer-events: none; opacity: 0;
  transform: translate(-50%, calc(-100% - 10px));
  background: rgba(26, 26, 46, .92); color: #fff; border-radius: 6px; padding: 6px 10px;
  font: 12px 'Raleway', sans-serif; white-space: nowrap; transition: opacity .12s;
}
</style>
